import { NAV } from "./Header";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#1B3A6B] text-white" data-testid="site-footer">
    <div className="als-container py-12">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between">
        <div>
          <p className="text-[15px] font-medium tracking-[0.02em] text-white">ARKA LIKAS SOLUTIONS</p>
          <p className="mt-2 text-[14px] text-white/60">Pasig City, Metro Manila, Philippines</p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-2 text-[15px] text-white/75">
          {NAV.map(([href, label]) => (
            <a key={href} href={href} className="footer-link" data-testid={`footer-${href.slice(1)}`}>{label}</a>
          ))}
        </nav>
      </div>
      <p className="mt-10 text-[11px] text-white/45">© 2026 Arka Likas Solutions Inc.</p>
    </div>
  </footer>
);
